import $ from 'jquery'
import isRetina from '../utils/isRetina'

$.fn.responsiveImage = function () {

	return this.each(function () {

		var el = $(this).addClass('responsive-image');
		var srcset = {};
		var sizes = [];
		var data = $(this).data('srcset') || $(this).data('bg-srcset');
		var width = 0;

		if (this.currentSrc && !this.currentSrc.match(/^data/) && this.naturalWidth) {
			width = this.naturalWidth;
		}

		var bgParent = el.closest('[data-bg], [data-bg-srcset]');
		var ref = bgParent.length ? bgParent : el;
		var isBg = bgParent.length > 0;
		var isImg = ($(this).data('srcset')) ? true : false;
		var delay = $(this).data('lazy');

		data.split(", ").forEach(w => {
			var d = w.split(/[\s]/);
			var w = d.length > 1 ? parseInt(d[1]) : 1;
			srcset[w] = d[0];
			sizes.push(w);
		});

		sizes = sizes.sort(function (a, b) {
			return b - a;
		});

		var setWidth = function () {
			if (delay) {
				return;
			}
			var w = getBestSize();


			if (w > width) {
				width = w;
				if (isBg) bgParent.css('backgroundImage', 'url(' + srcset[w] + ')');
				if (isImg) el.attr('src', srcset[w]);
			}
		};

		var getBestSize = function () {
			var iw = ref.outerWidth();
			var ih = ref.outerHeight();
			var r = 0;
			if (isRetina) {
				iw = iw * 2;
				ih = ih * 2;
			}
			if (isBg && isImg) {
				var w = parseInt(el.attr('width'));
				var h = parseInt(el.attr('height'));
				r = h / w;
			}
			var s = sizes.filter(function (s, i) {
				if (!i) {
					return true;
				}
				if (r) {
					var h = s * r;
					if (s > iw && h > ih) {
						return true;
					}
				} else if (s > iw) {
					return true;
				}
				return false;
			}).pop();
			return s;
		}

		$(window).on('resize', setWidth);

		el.on('lazy-load', function () {
			delay = 0;
			setWidth();
		});
		el.on('respond', function () {
			delay = 0;
			setWidth();
		});

		setWidth();

	});
}

$.fn.responsiveImages = function () {

	const el = $(this);
	const images = el.find('img[data-srcset], [data-bg-srcset]');

	images.responsiveImage();

}

export default {

	init: function (images) {
		if (typeof images == 'undefined') {
			images = $('img[data-srcset], [data-bg-srcset]');
		}
		$(images).not('.responsive-image,[data-lazy="delay"]').responsiveImage();
	},

	initEl: function (el, force) {
		const images = el.find('img[data-srcset], [data-bg-srcset]');
		if (force) {
			images.responsiveImage();
		} else {
			$(images).not('.responsive-image,[data-lazy="delay"]').responsiveImage();
		}
	},

}
